<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招接待宾馆预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>宾馆房间管理</el-breadcrumb-item>
        <el-breadcrumb-item>房间编辑</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <div>
        <el-form v-loading="formLoading" :model="listParams" label-width="150px">
          <el-form-item label="房间名称：">
            <el-input style="width: 300px;" size="small" v-model="listParams.name" placeholder="房间名称"> </el-input>
          </el-form-item>

          <el-form-item label="房间类型：">
            <el-select clearable style="width: 300px;" size="small" v-model="listParams.type" placeholder="房间类型" @change="currentSel">
              <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="房间面积：">
            <el-input style="width: 300px;" size="small" v-model="listParams.area" placeholder="请输入房间面积"> </el-input>
          </el-form-item>

          <el-form-item label="床型信息：">
            <div v-for="(bed, key) in listParams.bed" :key="key">
              <el-select clearable style="width: 100px;" size="small" v-model="bed.size" placeholder="床型">
                <el-option v-for="item in bedSize" :label="item.size" :value="item.id" :key="item.id"> </el-option>
              </el-select>
              <el-select clearable style="width: 100px;" size="small" v-model="bed.num" placeholder="数量">
                <el-option v-for="item in bedNum" :label="item.num" :value="item.id" :key="item.id"> </el-option>
              </el-select>
              <button
                v-if="key + 1 <= listParams.bed.length && listParams.bed.length != 1"
                style="background:rgb(139, 195, 74);border: none;margin-left:20px"
                type="button"
                class="el-button el-button--primary el-button--small"
                v-on:click="doDeleteBed(key)"
              >
                <span>删除</span>
              </button>

              <button
                v-if="listParams.bed.length == key + 1"
                style="background:rgb(0, 150, 136);border: none;margin-left:20px"
                type="button"
                class="el-button el-button--primary el-button--small"
                v-on:click="doAddBed"
              >
                <span>新增</span>
              </button>
            </div>
          </el-form-item>

          <el-form-item label="房价(¥)：">
            <el-input style="width: 300px;" size="small" v-model="listParams.price" placeholder="填写金额"> </el-input>
          </el-form-item>

          <el-form-item label="宾馆图片：" prop="pictures">
            <div class="upload-thumbnail-img" :loading="uploading">
              <i class="el-icon-circle-plus-outline upload-icon"></i>
              <input type="file" class="hidden-upload" accept=".png,.jpg,.jpeg,.gif" @change="doUpload" id="uploadDom" />
            </div>
            <div class="wrap-thumbnail-img" v-if="listParams.pictures.length > 0">
              <div class="thumbnail-img" v-for="(item, index) in listParams.pictures" :key="index">
                <div class="combined-img">
                  <img :src="item" alt="" class="thumbnail-img-wrapped" :key="index" />
                  <div class="hover-img">
                    <i class="el-icon-circle-close-outline close-btn" @click="deleteImg(index)"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item class="align-center" style="padding-bottom: 20px;margin-top:30px;">
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveAdd()">
              保存
            </el-button>
            <el-button size="small" @click="backToList">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      formLoading: false,
      listParams: {
        pictures: [],
        bed: []
      },
      isDisabled: false,
      commoditySpecList: [],
      restrictionRuleList: [],
      uploading: false,
      method: "",
      bedSize: [
        { size: "1.2", id: "1.2" },
        { size: "1.8", id: "1.8" }
      ],
      bedNum: [
        { num: "1", id: "1" },
        { num: "2", id: "2" },
        { num: "3", id: "3" }
      ],
      types: [
        { label: "普通间", value: "1" },
        { label: "双人间", value: "2" },
        { label: "三人间", value: "3" }
      ]
    };
  },
  mounted() {
    this.loadDetailPage(this.$route.query.roomId);
  },
  methods: {
    currentSel(selVal) {
      this.listParams.type = selVal;
    },
    loadDetailPage(id) {
      this.formLoading = true;
      this.$http({
        url: global.apiUrl + "/reception/hotel/room/detail?roomId=" + id,
        method: "GET"
      })
        .then((res) => {
          this.formLoading = false;
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              const data = res.body.data;
              Object.assign(this.listParams, data);
              // eslint-disable-next-line no-eval
              this.listParams.bed = eval("(" + this.listParams.bed + ")");
            } else {

            }
          }
        })
        .catch((err) => {
          this.formLoading = false;

          console.error(err);
        });
    },
    doAddBed() {
      this.listParams.bed.push({ size: "", num: "" });
    },
    doDeleteBed(key) {
      this.listParams.bed.splice(key, 1);
    },
    /**
     * 上传图片
     */
    doUpload() {
      if (this.listParams.pictures.length >= 6) {
        this.$message.error("最多上传6张图片");
        return;
      }
      this.uploading = true;
      const files = document.getElementById("uploadDom").files;
      const file = files[0];
      const params = new FormData();
      params.append("file", file);
      params.append("path", "upload/good-img");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then((res) => {
          this.uploading = false;
          this.listParams.pictures.push(res.data.data);
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * 删除图片
     * @param index
     */
    deleteImg(index) {
      this.listParams.pictures.splice(index, 1);
    },
    validate() {
      if (!this.listParams.name) {
        this.$message.error("请填写房间名");
        return false;
      }
      if (!this.listParams.type) {
        this.$message.error("请选择房间类型");
        return false;
      }
      if (!this.listParams.area) {
        this.$message.error("请填写房间面积");
        return false;
      }
      if (this.listParams.bed.length == 1 && (!this.listParams.bed[0].num || !this.listParams.bed[0].size)) {
        this.$message.error("请填写床的信息");
        return false;
      }
      if (!this.listParams.price) {
        this.$message.error("请填写房间价格");
        return false;
      }
      if (this.listParams.pictures.length == 0) {
        this.$message.error("请选择图片");
        return false;
      }
      //				const regx =/^\d*\.{0,1}\d{0,1}$/;
      //				if (!regx.test(this.listParams.area)) {
      //					this.$message.error('请填写正确的房间面积');
      //					return false;
      //				}
      //				if (!regx.test(this.listParams.price)) {
      //					this.$message.error('请填写正确的房间价格');
      //					return false;
      //				}
      return true;
    },
    saveAdd() {
      // 校验
      if (!this.validate()) {
        return;
      }
      this.isDisabled = true;
      let picture = "";
      this.listParams.pictures.forEach(function(value, index, array) {
        picture += array[index] + ",";
      });
      picture = picture.substring(0, picture.lastIndexOf(","));
      const bedArr = [];
      for (const i in this.listParams.bed) {
        const obj = this.listParams.bed[i];
        if (obj.num && obj.size) {
          bedArr.push(obj);
        }
      }
      const bed = JSON.stringify(bedArr);
      let orderType = 1;
      if (this.listParams.type == "双人间") {
        orderType = 2;
      } else if (this.listParams.type == "三人间") {
        orderType = 3;
      }
      const bodyParams = Object.assign(
        {},
        {
          roomId: this.$route.query.roomId,
          name: this.listParams.name,
          description: "",
          pictures: picture,
          price: parseInt(this.listParams.price),
          festivalPrice: parseInt(this.listParams.price),
          officeFestivalPrice: parseInt(this.listParams.price),
          officePrice: parseInt(this.listParams.price),
          type: orderType,
          area: this.listParams.area,
          bed: bed
        }
      );

      this.$http({
        url: global.apiUrl + "/reception/hotel/room/edit",
        method: "POST",
        body: bodyParams,
        emulateJSON: true
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.$message.success(res.body.info);
            this.$router.push({
              name: "roomManage"
            });
          } else {

            this.tableLoading = false;
          }
        })
        .catch((err) => {
          this.tableLoading = false;

          console.error(err);
        });
    },

    backToList() {
      this.$router.push({
        name: "roomManage"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.hx-form-container {
  .wang-editor-style {
    height: 600px;

    .wang-editor-body {
      height: 540px;
    }
  }
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;
      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;
        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }
      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
}
</style>
